module.exports = "/_next/static/images/avatar_Andy-42e1620d6cba214f0997d8f3445e02cf.svg";